import { render, staticRenderFns } from "./sender.vue?vue&type=template&id=3338a896&scoped=true"
import script from "./sender.ts?vue&type=script&lang=ts&external"
export * from "./sender.ts?vue&type=script&lang=ts&external"
import style0 from "./sender.scoped.scss?vue&type=style&index=0&id=3338a896&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3338a896",
  null
  
)

export default component.exports